<h1 matDialogTitle>
	<div class="flex items-center">
		<div>{{ 'reports.export' | translate }}</div>
		<div class="flex-auto"></div>
		<div class="flex items-center space-x-2">
			<button
				[disabled]="closeDisabled"
				mat-icon-button
				matDialogClose
				tabindex="-1"
			>
				<mat-icon>close</mat-icon>
			</button>
		</div>
	</div>
</h1>
<mat-dialog-content cdkTrapFocus>
	<form
		(submit)="$event.preventDefault()"
		[formGroup]="this.group"
		class="mb-3"
	>
		<div class="flex flex-col items-stretch justify-start gap-2">
			<div class="flex flex-col gap-1">
				<div class="mat-typography mat-hint">{{ 'reports.exports.fileFormat' | translate }}</div>
				<mat-radio-group
					class="file-type-group grid grid-cols-1 sm:grid-cols-3 gap-2 mb-4"
					formControlName="fileType"
				>
					<mat-radio-button
						[class.file-type-option--active]="group.value.fileType === fileType.value"
						[value]="fileType.value"
						*ngFor="let fileType of visibleFileTypeOptions; trackProp: 'value'"
						class="file-type-option"
					>
						<div class="file-type-option__content">
							<div class="file-type-option__left">
								<div class="file-type-option__icon-wrap">
									<mat-icon class="file-type-option__icon">{{ fileType.icon }}</mat-icon>
								</div>
								<div class="flex flex-col leading-tight">
									<span class="font-medium">{{ fileType.title }}</span>
									<span class="mat-hint text-xs">{{ fileType.description }}</span>
								</div>
							</div>
							<div
								*ngIf="group.value.fileType === fileType.value"
								class="file-type-option__active-indicator"
							>
								<mat-icon>check</mat-icon>
							</div>
						</div>
					</mat-radio-button>
				</mat-radio-group>
			</div>
			<ng-container *ngIf="showExportTypeSelector">
				<mat-form-field appearance="fill">
					<mat-label>{{ 'reports.exports.exportStructure' | translate }}</mat-label>
					<mat-select formControlName="exportType">
						<mat-option
							[value]="item.name"
							*ngFor="let item of filteredExportTypes$.value$ | async; trackProp: 'name'"
							>{{
								item.name | translate
							}}</mat-option
						>
					</mat-select>
					<mat-error
						*ngIf="getErrorObservable('exportType', 'reports.exports.exportStructure') | async as error"
					>
						{{ error.content | translate: error.args || {} }}
					</mat-error>
				</mat-form-field>
			</ng-container>
			<div
				*ngIf="shouldShowPdfExportHint"
				class="mat-typography mat-hint -mt-1"
			>
				{{ pdfExportHintKey | translate }}
			</div>
			@if (selectedProjectSummaryUser$ | async) {

			<mat-form-field appearance="fill">
				<mat-label>{{ 'reports.exports.projectSummaryUserMetric' | translate }}</mat-label>
				<mat-select formControlName="projectSummaryUserMetric">
					<mat-option
						[value]="item.value"
						*ngFor="let item of projectSummaryUserMetricOptions; trackProp: 'value'"
					>
						{{ item.name | translate }}
					</mat-option>
				</mat-select>
			</mat-form-field>
			<mat-form-field appearance="fill">
				<mat-label>{{ 'reports.exports.projectSummaryUserProjectAlias' | translate }}</mat-label>
				<mat-select formControlName="projectSummaryUserProjectAlias">
					<mat-option
						[value]="item.value"
						*ngFor="let item of projectSummaryUserProjectAliasOptions; trackProp: 'value'"
					>
						{{ ('reports.exports.projectSummaryUserProjectAliasOptions.' + item.value) | translate }}
					</mat-option>
				</mat-select>
				<mat-hint>{{ 'reports.exports.projectSummaryUserProjectAliasHint' | translate }}</mat-hint>
			</mat-form-field>
			}
			<div
				*ngIf="hasColumns$ | async"
				class="flex flex-col"
			>
				<div class="rounded-lg mat-bg flex flex-col px-3.5 py-3 gap-2">
					<div class="flex flex-col lg:flex-row lg:items-center gap-2">
						<div class="flex flex-col flex-auto">
							<div class="text-base leading-tight font-semibold">
								{{ 'reports.export-columns.label' | translate }}
								({{ (selectedExportColumns$.value$ | async) | length }}/{{
									(exportColumns.value$ | async) | length
								}}
								{{ 'reports.export-columns.selected' | translate }})
							</div>
							<div class="mat-typography mat-hint">
								{{ 'reports.export-columns.orderNotice' | translate }}
							</div>
						</div>
						<div class="flex flex-wrap items-center justify-items-end gap-1 flex-shrink-0 justify-end">
							<button
								(click)="selectAllColumns()"
								class="!min-w-0 !h-7 !px-2.5 !leading-7"
								mat-button
								type="button"
							>
								{{ 'reports.export-columns.selectAll' | translate }}
							</button>
							<div class="h-4 w-px mat-bg-5"></div>
							<button
								(click)="clearSelectedColumns()"
								class="!min-w-0 !h-7 !px-2.5 !leading-7"
								mat-button
								type="button"
							>
								{{ 'reports.export-columns.clearSelection' | translate }}
							</button>
						</div>
					</div>
					<div class="h-px mat-bg-5"></div>
					<div
						class="columns-1 gap-x-1 pt-2 md:columns-2 lg:columns-3 pb-4"
						formGroupName="columns"
					>
						<ng-container
							*ngFor="let groupColumns of groupedExportColumns$.value$ | async; let index = index; trackProp: 'nameKey'"
						>
							<div class="mb-4 break-inside-avoid flex flex-col">
								<div class="mb-1 text-sm font-semibold">{{ groupColumns.nameKey | translate }}</div>
								<ng-container *ngFor="let col of groupColumns.columns; trackProp">
									<mat-checkbox
										[formControlName]="col"
										class="mat-checkbox-truncate mat-checkbox-flex"
										color="primary"
									>
										<span class="truncate">{{ 'reports.export-column.' + col | translate }}</span>
									</mat-checkbox>
								</ng-container>
							</div>
						</ng-container>
					</div>
					<div class="h-px mat-bg-5"></div>

					<div class="flex py-1 flex-shrink-0">
						<div class="flex gap-x-2 text-muted items-center">
							<mat-icon inline>info</mat-icon>
							<span class="text-sm leading-none">{{
								'reports.export-columns.savedAutomatically' | translate
							}}</span>
						</div>
					</div>
				</div>
			</div>
			<div
				*ngIf="!(selectedSummaryLike$ | async)"
				class="mat-bg flex items-center space-x-4 rounded-lg px-3.5"
			>
				<mat-slide-toggle
					(click.native)="group.patchValue({ timezone: group.value.timezone === 'keep' ? 'adjust' : 'keep' })"
					[checked]="group.value.timezone === 'adjust'"
					[disabled]="group.controls.timezone?.disabled"
					class="mat-slide-toggle-flex w-full"
					color="primary"
					labelPosition="before"
				>
					<div class="flex h-16 flex-1 items-center space-x-4">
						<div class="flex flex-1 flex-col space-y-0.5">
							<span>{{ 'reports.exports.timezone' | translate }}</span>
							<div class="mat-typography mat-hint flex items-center space-x-1.5 leading-tight">
								<mat-icon inline>info</mat-icon>
								<span>{{ 'reports.exports.timezoneNotice' | translate }}</span>
							</div>
						</div>
					</div>
				</mat-slide-toggle>
			</div>
			<div class="mat-bg flex items-center space-x-4 rounded-lg px-3.5">
				<mat-slide-toggle
					(click.native)="onRoundingHandle()"
					[checked]="group.value.rounding?.enabled"
					[disabled]="group.controls.rounding?.disabled"
					class="mat-slide-toggle-flex w-full"
					color="primary"
					labelPosition="before"
				>
					<div class="flex h-16 flex-1 items-center space-x-4">
						<div class="flex flex-1 flex-col space-y-0.5">
							<span>{{ 'reports.export-rounding' | translate }}</span>
							<div class="mat-typography mat-hint flex items-center space-x-1.5 leading-tight">
								<mat-icon inline>info</mat-icon>
								<span>{{ 'reports.export-rounding-notice' | translate }}</span>
							</div>
						</div>
						<button
							(click.native)="onRoundingHandle(true)"
							[disabled]="group.controls.rounding?.disabled"
							*ngIf="group.value.rounding?.enabled"
							mat-stroked-button
						>
							{{ 'utils.edit' | translate }}
						</button>
					</div>
				</mat-slide-toggle>
			</div>
		</div>
	</form>
</mat-dialog-content>
<mat-dialog-actions class="flex lg:justify-end lg:flex-row">
	<ng-container
		*ngTemplateOutlet="
      !isLoading ? submitButton : submitWaitButton;
      context: { disabled: group.invalid || group.disabled }
    "
	></ng-container>
</mat-dialog-actions>
<ng-template
	#submitButton
	let-disabled="disabled"
>
	<button
		(click)="close()"
		[disabled]="disabled"
		class="!px-6 !h-10 !rounded-lg"
		mat-stroked-button
	>
		{{ 'utils.cancel' | translate }}
	</button>
	<button
		(click)="submit()"
		[disabled]="disabled || closeDisabled"
		class="!px-6 !h-10 !rounded-lg lg:!w-[168px]"
		color="primary"
		mat-flat-button
	>
		{{ 'reports.export-download' | translate }}
	</button>
</ng-template>
<ng-template #submitWaitButton>
	<button
		[disabled]="true"
		class="!px-6 !h-10 !rounded-lg lg:!w-[168px]"
		color="primary"
		mat-flat-button
	>
		<div class="flex items-center justify-center space-x-2">
			<mat-spinner
				[diameter]="16"
				[strokeWidth]="2"
				mode="indeterminate"
			></mat-spinner>
			<span>{{ 'reports.export-downloading' | translate }}</span>
			<span *ngIf="(progress.value$ | async)?.progress as p">{{ p | percent: 1 : 2 }}</span>
		</div>
	</button>
</ng-template>
